import { useEffect } from 'react'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { fetchFiltersCallback } from './callbacks'
import type { SelectFiltersState } from './model'
import { filtersState } from './state'

const useSelectFilters = (): SelectFiltersState => {
  const fetchFilters = useRecoilCallback(fetchFiltersCallback, [])

  const s = useRecoilValue(filtersState)

  useEffect(() => {
    void fetchFilters()
  }, [])

  return s
}

export default useSelectFilters
